// 폼 검증 유틸리티 함수들

// 이메일 검증
export const validateEmail = (email) => {
  if (!email) return '이메일을 입력해주세요.';

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return '올바른 이메일 형식이 아닙니다.';
  }

  return '';
};

// 비밀번호 검증
export const validatePassword = (password) => {
  if (!password) return '비밀번호를 입력해주세요.';

  if (password.length < 8) {
    return '비밀번호는 최소 8자 이상이어야 합니다.';
  }

  if (!/[a-zA-Z]/.test(password) || !/\d/.test(password)) {
    return '비밀번호는 영문자와 숫자를 모두 포함해야 합니다.';
  }

  return '';
};

// 전화번호 검증
export const validatePhone = (phone) => {
  if (!phone) return '전화번호를 입력해주세요.';

  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length < 10 || cleaned.length > 11) {
    return '올바른 전화번호 형식이 아닙니다.';
  }

  const phoneRegex = /^01[0-9]-?\d{3,4}-?\d{4}$/;
  if (!phoneRegex.test(phone.replace(/-/g, ''))) {
    return '올바른 휴대폰 번호를 입력해주세요.';
  }

  return '';
};

// 이름 검증
export const validateName = (name) => {
  if (!name) return '이름을 입력해주세요.';

  if (name.length < 2) {
    return '이름은 최소 2자 이상이어야 합니다.';
  }

  if (name.length > 20) {
    return '이름은 최대 20자까지 입력 가능합니다.';
  }

  const nameRegex = /^[가-힣a-zA-Z\s]+$/;
  if (!nameRegex.test(name)) {
    return '이름은 한글 또는 영문만 입력 가능합니다.';
  }

  return '';
};

// 필수 필드 검증
export const validateRequired = (value, fieldName = '필드') => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return `${fieldName}을(를) 입력해주세요.`;
  }
  return '';
};

// 날짜 검증
export const validateDate = (date) => {
  if (!date) return '날짜를 선택해주세요.';

  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(date)) {
    return '올바른 날짜 형식이 아닙니다. (YYYY-MM-DD)';
  }

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return '유효하지 않은 날짜입니다.';
  }

  return '';
};

// 생년월일 검증
export const validateBirthDate = (date) => {
  const dateError = validateDate(date);
  if (dateError) return dateError;

  const birthDate = new Date(date);
  const today = new Date();

  if (birthDate > today) {
    return '생년월일은 오늘 이전이어야 합니다.';
  }

  const age = today.getFullYear() - birthDate.getFullYear();
  if (age > 150) {
    return '올바른 생년월일을 입력해주세요.';
  }

  return '';
};

// 발인일시 검증
export const validateDepartureDate = (date) => {
  const dateError = validateDate(date);
  if (dateError) return dateError;

  const departureDate = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (departureDate < today) {
    return '발인일은 오늘 이후여야 합니다.';
  }

  return '';
};

// 주소 검증
export const validateAddress = (address) => {
  if (!address) return '주소를 입력해주세요.';

  if (address.length < 10) {
    return '올바른 주소를 입력해주세요.';
  }

  return '';
};

// 금액 검증
export const validateAmount = (amount, min = 0, max = null) => {
  if (!amount && amount !== 0) return '금액을 입력해주세요.';

  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(numAmount)) {
    return '올바른 금액을 입력해주세요.';
  }

  if (numAmount < min) {
    return `금액은 최소 ${min.toLocaleString()}원 이상이어야 합니다.`;
  }

  if (max && numAmount > max) {
    return `금액은 최대 ${max.toLocaleString()}원 이하여야 합니다.`;
  }

  return '';
};

// 문자 길이 검증
export const validateLength = (text, min = 0, max = null, fieldName = '내용') => {
  if (!text) {
    if (min > 0) return `${fieldName}을(를) 입력해주세요.`;
    return '';
  }

  const length = text.length;

  if (length < min) {
    return `${fieldName}은(는) 최소 ${min}자 이상이어야 합니다.`;
  }

  if (max && length > max) {
    return `${fieldName}은(는) 최대 ${max}자까지 입력 가능합니다.`;
  }

  return '';
};

// 부고 작성 폼 전체 검증
export const validateObituaryForm = (formData) => {
  const errors = {};

  // 고인 정보
  errors.deceasedName = validateName(formData.deceasedName);
  errors.deceasedBirthDate = validateBirthDate(formData.deceasedBirthDate);
  errors.relationship = validateRequired(formData.relationship, '고인과의 관계');

  // 장례 정보
  errors.funeralHome = validateRequired(formData.funeralHome, '장례식장');
  errors.funeralAddress = validateAddress(formData.funeralAddress);
  errors.departureDate = validateDepartureDate(formData.departureDate);

  // 상주 정보
  errors.chiefMourner = validateName(formData.chiefMourner);
  errors.chiefMournerPhone = validatePhone(formData.chiefMournerPhone);
  errors.chiefMournerRelationship = validateRequired(formData.chiefMournerRelationship, '상주와의 관계');

  // 에러가 있는 필드만 반환
  const filteredErrors = Object.entries(errors).reduce((acc, [key, value]) => {
    if (value) acc[key] = value;
    return acc;
  }, {});

  return {
    isValid: Object.keys(filteredErrors).length === 0,
    errors: filteredErrors
  };
};

// 로그인 폼 검증
export const validateLoginForm = (formData) => {
  const errors = {};

  errors.email = validateEmail(formData.email);
  errors.password = validateRequired(formData.password, '비밀번호');

  const filteredErrors = Object.entries(errors).reduce((acc, [key, value]) => {
    if (value) acc[key] = value;
    return acc;
  }, {});

  return {
    isValid: Object.keys(filteredErrors).length === 0,
    errors: filteredErrors
  };
};

// 회원가입 폼 검증
export const validateSignupForm = (formData) => {
  const errors = {};

  errors.name = validateName(formData.name);
  errors.email = validateEmail(formData.email);
  errors.phone = validatePhone(formData.phone);
  errors.password = validatePassword(formData.password);

  if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = '비밀번호가 일치하지 않습니다.';
  }

  const filteredErrors = Object.entries(errors).reduce((acc, [key, value]) => {
    if (value) acc[key] = value;
    return acc;
  }, {});

  return {
    isValid: Object.keys(filteredErrors).length === 0,
    errors: filteredErrors
  };
};
